export default __webpack_public_path__ + "static/light-76d58cf6903ccf27e9e9510cd05529db.woff2";